// Little Ounce: сцена из кадров. Одна липкая сцена, прокрутка листает кадры, тексты и карточку товара.
// Устройство взято с svalto.com: один цикл requestAnimationFrame с инерцией (позиция догоняет палец), цикл спит вне экрана.
// У каждой сцены есть «полка»: участок прокрутки, где картинка и текст стоят. Если палец остановился рядом с полкой,
// страница мягко доезжает до неё. Так видно, что дошёл до места, где можно остановиться и прочитать.
(function () {
  var root = document.querySelector('[data-lo-scenes]');
  if (!root || root.__lo) return;
  root.__lo = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window) || !window.requestAnimationFrame) return;

  var frames = [].slice.call(root.querySelectorAll('.lo-scenes__frame'));
  var steps = [].slice.call(root.querySelectorAll('.lo-scenes__step'));
  var card = root.querySelector('.lo-scenes__card');
  var dots = [].slice.call(root.querySelectorAll('.lo-scenes__dots i'));
  var hint = root.querySelector('.lo-scenes__hint');
  var n = frames.length;

  // Видео-петли поверх кадров. Файл берётся после загрузки страницы, чтобы не мешать первому экрану; играет только видимый кадр.
  function frameOn(el, i) { return el.style.opacity === '' ? i === 0 : +el.style.opacity > 0.5; }
  function syncVideo(el, on) {
    var v = el.__v; if (!v || !v.__ready) return;
    if (on && v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    else if (!on && !v.paused) v.pause();
  }
  function startVideos() {
    var wide = window.matchMedia('(min-width: 900px)').matches;
    frames.forEach(function (el, i) {
      var v = el.querySelector('video'); if (!v) return;
      var src = wide ? v.getAttribute('data-src-d') : v.getAttribute('data-src-m'); if (!src) return;
      el.__v = v;
      v.addEventListener('canplay', function () { v.__ready = true; syncVideo(el, frameOn(el, i)); }, { once: true });
      v.addEventListener('playing', function () { v.classList.add('is-on'); }, { once: true });
      v.muted = true; v.src = src; v.load();
    });
  }
  if (document.readyState === 'complete') setTimeout(startVideos, 300);
  else window.addEventListener('load', function () { setTimeout(startVideos, 300); });

  if (n < 2) return;

  var TAIL = card ? 1 : 0.3;              // сколько «экранов» сцена держит последний кадр с карточкой
  var UNITS = n + TAIL;
  var ZOOM = 0.2;                         // сила наезда: 0.2 это 20% за жизнь кадра
  var REST = 0.5;                         // где внутри сцены стоит полка (доля сцены)
  var PULL = 0.5;                         // как далеко от полки страница доезжает сама: 0.5 значит, что между сценами остановиться нельзя
  root.style.height = Math.round(UNITS * 125 + 100) + 'svh';   // 1,25 экрана прокрутки на сцену
  root.classList.add('lo-scenes--on');
  frames.forEach(function (f) { var img = f.querySelector('img'); if (img) img.loading = 'eager'; });

  // Кто прокручивается: окно или обёртка темы (у Horizon на широких экранах это .page-wrapper).
  var scroller = null;
  for (var el = root.parentElement; el && el !== document.body; el = el.parentElement) {
    var oy = getComputedStyle(el).overflowY;
    if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight + 4) { scroller = el; break; }
  }
  function scrollTop() { return scroller ? scroller.scrollTop : (window.pageYOffset || document.documentElement.scrollTop || 0); }
  function scrollToY(y) { (scroller || window).scrollTo({ top: y, behavior: 'smooth' }); }

  var cur = 0, first = true, raf = 0, inView = false, lastT = 0, lastDrawn = -1;
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ease(v) { return v * v * (3 - 2 * v); }
  function easeOut(v) { return 1 - Math.pow(1 - v, 3); }
  function track() { return root.getBoundingClientRect().height - window.innerHeight; }
  function target() {
    var total = track();
    return total > 0 ? clamp(-root.getBoundingClientRect().top / total) : 0;
  }
  function draw(p) {
    if (Math.abs(p - lastDrawn) < 0.0004) return;
    lastDrawn = p;
    var f = p * UNITS;                     // «номер сцены» с дробной частью
    frames.forEach(function (el, i) {
      var o = i === 0 ? 1 : ease(clamp((f - i + 0.16) / 0.32));   // смена кадра короткая, чтобы дальше картинка стояла
      var arrive = easeOut(clamp((f - i + (i === 0 ? 0 : 0.16)) / 0.6));   // к полке наезд почти закончен; первый кадр стартует без наезда
      var drift = clamp((f - i - 0.44) / 0.8) * 0.18;             // на полке остаётся едва заметное движение
      var t = clamp(arrive * 0.82 + drift);
      var z = i % 2 === 0 ? 1 + ZOOM * t : 1 + ZOOM * (1 - t);    // чётные кадры наезжают, нечётные отъезжают
      el.style.opacity = o;
      el.style.transform = 'scale(' + z.toFixed(4) + ')';
      var covered = i < n - 1 && clamp((f - i - 1 + 0.16) / 0.32) >= 1;   // следующий кадр уже полностью сверху
      syncVideo(el, o > 0.5 && !covered);
    });
    var open = !!card && f >= n - 0.12;
    steps.forEach(function (el, i) {
      var last = i === n - 1;
      var inn = i === 0 ? 1 : easeOut(clamp((f - i + 0.04) / 0.24));
      var outStart = last ? n - 0.3 : i + 0.74;
      var out = clamp((f - outStart) / 0.18);
      if (last && !card) out = 0;
      var o = Math.min(inn, 1 - out);
      el.style.opacity = o;
      el.style.transform = out > 0 ? 'translateY(' + (-46 * out) + 'px)' : 'translateY(' + (22 * (1 - inn)) + 'px)';
      el.style.filter = out > 0 ? 'blur(' + (10 * out).toFixed(1) + 'px)' : '';
      el.style.pointerEvents = o > 0.5 ? 'auto' : 'none';
    });
    dots.forEach(function (d, i) { d.style.transform = 'scaleX(' + clamp((f - i) / (i < n ? 1 : TAIL)).toFixed(3) + ')'; });
    if (hint) hint.style.opacity = f < 0.25 ? 1 : 0;
    if (card) {
      card.classList.toggle('is-open', open);
      root.classList.toggle('is-card', open);
    }
  }
  function tick(now) {
    raf = 0;
    if (!inView) return;
    var dt = lastT ? Math.min(64, now - lastT) : 16.667; lastT = now;
    var t = target();
    if (first) { cur = t; first = false; }
    var d = t - cur, k = 1 - Math.pow(0.93, dt / 16.667);       // 7% разрыва за кадр: мягкая инерция
    cur = Math.abs(d) < 0.0005 ? t : cur + d * k;
    draw(cur);
    raf = requestAnimationFrame(tick);
  }
  new IntersectionObserver(function (en) {
    inView = en[en.length - 1].isIntersecting;
    if (!inView) frames.forEach(function (el) { syncVideo(el, false); }); else lastDrawn = -1;
    if (inView && !raf) { lastT = 0; raf = requestAnimationFrame(tick); }
  }, { rootMargin: '120px 0px' }).observe(root);

  // Доезд до полки. Срабатывает, когда прокрутка остановилась, и только рядом с полкой: быстро пролистать сцену это не мешает.
  var rests = [];
  for (var i = 1; i < n; i++) rests.push(i + REST);
  if (card) rests.push(n + TAIL * 0.45);
  var idle = 0, auto = 0, touching = false;
  function settle() {
    if (touching || Date.now() < auto) return;
    var total = track(); if (total <= 0) return;
    var p = -root.getBoundingClientRect().top / total;
    if (p <= 0.02 || p >= 0.995) return;                         // выше или ниже сцены не вмешиваемся
    var f = p * UNITS, best = null, dist = 9;
    rests.forEach(function (r) { var dd = Math.abs(f - r); if (dd < dist) { dist = dd; best = r; } });
    if (best === null || dist > PULL || dist < 0.03) return;
    auto = Date.now() + 700;
    scrollToY(scrollTop() + (best / UNITS - p) * total);
  }
  function onScroll() { clearTimeout(idle); idle = setTimeout(settle, 150); }
  (scroller || window).addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('touchstart', function () { touching = true; clearTimeout(idle); }, { passive: true });
  window.addEventListener('touchend', function () { touching = false; onScroll(); }, { passive: true });
})();
